
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 10 12","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.75 1.838c0-.81.883-1.31 1.578-.893l6.933 4.16a1.042 1.042 0 010 1.786l-6.933 4.16a1.042 1.042 0 01-1.578-.893v-8.32z","fill":"#56BFC7"}})])
          )
        }
      }
    